import { Source, Layer } from 'react-map-gl'

interface ZonesLayersProps {
  readonly zonesSourceId: string
  readonly zonesLayerId: string
  readonly zonesOutlineLayerId: string
  readonly zonesGeoJSON: GeoJSON.FeatureCollection
  readonly editingZoneId: string | null
}

export function ZonesLayers({
  zonesSourceId,
  zonesLayerId,
  zonesOutlineLayerId,
  zonesGeoJSON,
  editingZoneId,
}: ZonesLayersProps) {
  return (
    <Source
      key={`zones-source-${editingZoneId ?? 'none'}-${zonesGeoJSON.features.length}`}
      id={zonesSourceId}
      type='geojson'
      data={zonesGeoJSON}
    >
      <Layer
        id={zonesLayerId}
        type='fill'
        layout={{
          visibility: editingZoneId ? 'none' : 'visible',
        }}
        paint={{
          'fill-color': [
            'case',
            ['>=', ['get', 'score'], 5],
            '#dc2626',
            ['>=', ['get', 'score'], 4],
            '#ea580c',
            ['>=', ['get', 'score'], 2],
            '#eab308',
            ['>=', ['get', 'score'], 1],
            '#84cc16',
            ['>=', ['get', 'score'], 0],
            '#22c55e',
            '#ea580c',
          ],
          'fill-opacity': 0.6,
        }}
      />
      <Layer
        id={zonesOutlineLayerId}
        type='line'
        layout={{
          visibility: editingZoneId ? 'none' : 'visible',
        }}
        paint={{
          'line-color': [
            'case',
            ['>=', ['get', 'score'], 5],
            '#dc2626',
            ['>=', ['get', 'score'], 4],
            '#ea580c',
            ['>=', ['get', 'score'], 2],
            '#eab308',
            ['>=', ['get', 'score'], 1],
            '#84cc16',
            ['>=', ['get', 'score'], 0],
            '#22c55e',
            '#ea580c',
          ],
          'line-width': 3,
          'line-opacity': 1,
        }}
      />
    </Source>
  )
}
